import { Flex, Typography } from 'antd';
import React, { useState } from 'react';
import classes from './Balance.module.css';
import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from 'shared/config/store/store';
import { RoundContainer } from 'shared/ui';
import {
  getUserSecureState,
  setUserSecure,
} from 'shared/config/store/reducers/userSlice';
import { splitBalance } from 'shared/libs/utils/helpers';

type BalanceProps = {
  balance: number;
};

const Balance: React.FC<BalanceProps> = ({ balance }) => {
  const [wholePart, fractionalPart] = splitBalance(balance);
  const hide = useSelector(getUserSecureState);
  const dispatch = useDispatch<AppDispatch>();

  const toggleSecured = () => {
    dispatch(setUserSecure(!hide));
  };

  return (
    <Flex justify="space-between" align="center">
      <Typography.Text
        className={classes.balance}
        id={hide ? 'balance-hidden' : 'balance-shown'}>
        {hide ? '**' : wholePart},
        <Typography.Text className={classes.fractionalPart}>
          {hide ? '**' : fractionalPart} €
        </Typography.Text>
      </Typography.Text>
      <RoundContainer
        id="#btn__show-balance"
        size={32}
        color={'rgba(0, 0, 0, 0.1)'}
        pointer
        onClick={toggleSecured}>
        {hide ? (
          <EyeOutlined style={{ fontSize: 20 }} />
        ) : (
          <EyeInvisibleOutlined style={{ fontSize: 20 }} />
        )}
      </RoundContainer>
    </Flex>
  );
};

export default Balance;
